
import { X, ChevronRight } from "lucide-react";
import { useState } from "react";

interface FileListProps {
  files: File[];
  isMedia: boolean;
  removeFile: (index: number, isMedia: boolean) => void;
}

export const FileList = ({ files, isMedia, removeFile }: FileListProps) => {
  const [showAllFiles, setShowAllFiles] = useState(false);

  if (files.length === 0) return null;

  const displayCount = showAllFiles ? files.length : 1;
  const remainingCount = files.length - displayCount;

  return (
    <div className="mt-2 space-y-2">
      {files.slice(0, displayCount).map((file, index) => (
        <div
          key={index}
          className="flex items-center justify-between p-2 bg-black/10 rounded-lg text-sm text-white"
        >
          <span className="truncate flex-1">{file.name}</span>
          <button
            onClick={() => removeFile(index, isMedia)}
            className="ml-2 p-1 hover:bg-black/20 rounded-full transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
      {remainingCount > 0 && (
        <button
          onClick={() => setShowAllFiles(!showAllFiles)}
          className="flex items-center text-sm text-flux-cyan hover:underline"
        >
          {showAllFiles ? "Show less" : `See all (${files.length})`}
          <ChevronRight className="w-4 h-4 ml-1" />
        </button>
      )}
    </div>
  );
};
